import TarjetaRipleyIcon from '../../../common/icons/ic_TarjetaRipley.svg';
import PurchasesRipleyComIcon from '../../../common/icons/ic_PurchasesRipleyCom.svg';
import GiftCardsIcon from '../../../common/icons/ic_GiftCard.svg';
import ClubsIcon from '../../../common/icons/rclubes.svg';

export const REQUESTS = [
  {
    id: 6,
    title: 'Tarjeta Ripley',
    dataCy: 'RipleyCardProblems',
    subtitle: 'Bloqueos, consulta puntos y mucho más.',
    icon: TarjetaRipleyIcon,
    motives: [
      {
        id: 25,
        title: 'Bloqueo Tarjeta Ripley',
        dataCy: 'BlockCardProblem',
        type: 6,
      },
      {
        id: 12,
        title: 'Cambio Tarjeta Ripley',
        dataCy: 'ChangeCardProblem',
        type: 6,
      },
      {
        id: 24,
        title: 'Pago de estado de cuenta',
        dataCy: 'PayCardProblem',
        type: 6,
      },
      {
        id: 20,
        title: 'Ripley Puntos Go',
        dataCy: 'RPGOProblem',
        type: 6,
      },
      {
        id: 23,
        title: 'Seguros Ripley',
        dataCy: 'InsurancesProblem',
        type: 6,
      },
    ],
  },
  {
    id: 2,
    title: 'Compras en ripley.com',
    dataCy: 'PurchasesRipleyProblems',
    subtitle: 'Pide una copia de tu boleta y reporta inconvenientes.',
    icon: PurchasesRipleyComIcon,
    motives: [
      {
        id: 33,
        title: 'Error en la página',
        dataCy: 'ErrorPageProblem',
        type: 7,
      },
      {
        id: 17,
        title: 'Inconveniente al momento de comprar',
        dataCy: 'PurchaseProblem',
        type: 7,
      },
    ],
  },
  {
    id: 3,
    title: 'Gift cards',
    dataCy: 'GiftCardsProblems',
    subtitle: '¿Deseas extender vigencia? Hazlo desde esta opción.',
    icon: GiftCardsIcon,
    motives: [
      {
        id: 36,
        title: 'Inconveniente con mi Gift Card',
        dataCy: 'GiftCardProblem',
        type: 9,
      },
      {
        id: 31,
        title: 'Extender vigencia Gift Card',
        dataCy: 'ExtendGiftCardProblem',
        type: 9,
      },
      {
        id: 32,
        title: 'Extender vigencia Gift Card empresa',
        dataCy: 'ExtendCompanyGiftCardProblem',
        type: 9,
      },
    ],
  },
  {
    id: 11,
    title: 'Clubes Ripley',
    dataCy: 'ClubsProblems',
    subtitle: 'Dudas, consulta de canjes y muchos más',
    icon: ClubsIcon,
    motives: [
      {
        id: 'general-clubs',
        title: 'Solicitudes frecuentes',
        dataCy: 'ClubsGeneralProblem',
        type: 11,
      },
    ],
  },
];
